import React, { useContext } from "react";
import { AuthContext } from "../../../../../../../../contexts/AuthContext";
import { ProcessContext } from "../../../../../../../../contexts/ProcessContext";
import {
  Box,
  Slider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Text from "../../../../../../../shared/components/Text";
import { THEME_NAMES } from "../../../../../../../../config/themes/config";
import { formatMoney } from "@nemuru-eng/js-api-client";

export const THEMES_TO_ENABLE_QUOTA_SELECTION = [THEME_NAMES.caixabank];

export const AdjustLoanSlider = ({
  termMarks,
  minTerm,
  maxTerm,
  loanConditions,
  handleLoanTermSlider,
  onBoardingByBorrower,
  hasMultiplePricings,
}) => {
  const {
    state: { agent },
  } = useContext(AuthContext);
  const {
    state: { loanCalculator },
  } = useContext(ProcessContext);
  const { palette, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));

  const { period, quota, currency } = loanConditions;

  const { quota_selection_by_borrower_is_allowed } = agent;

  const quotaSelectionEnabledByTheme =
    THEMES_TO_ENABLE_QUOTA_SELECTION.includes(agent.custom_theme);

  const allowQuotaSelection =
    quotaSelectionEnabledByTheme &&
    quota_selection_by_borrower_is_allowed &&
    loanCalculator &&
    onBoardingByBorrower &&
    termMarks &&
    termMarks.length > 1;

  const formatAmount = (value) => {
    if (value === undefined) return "-";
    return formatMoney({ value, currency: currency ?? "EUR" }, 2);
  };

  return (
    <>
      {allowQuotaSelection && (
        <Typography
          style={{ color: palette.text.title }}
          variant={isScreenXs ? "caption" : "caption"}
        >
          <Text tId="ADJUST_YOUR_QUOTA" />
        </Typography>
      )}
      <Box mt={1} />
      <Typography
        style={{ color: palette.text.title }}
        variant={isScreenXs ? "h6" : "h5"}
      >
        <strong>
          {hasMultiplePricings && (
            <>
              <Text tId={"FROM"} />{" "}
            </>
          )}
          <Text
            tId={"MONEY_PER_MONTH"}
            dynamicDataTexts={[formatAmount(quota)]}
          />
        </strong>
      </Typography>
      {allowQuotaSelection && (
        <Box width={"95%"}>
          <Slider
            aria-label="Adjust quota by moving the slider"
            aria-labelledby="continuous-slider"
            step={null}
            value={period}
            defaultValue={maxTerm}
            min={minTerm}
            max={maxTerm}
            marks={termMarks}
            onChange={handleLoanTermSlider}
          />
        </Box>
      )}
    </>
  );
};
